// extracted by mini-css-extract-plugin
export default {"inputWrap":"consultationFormAdditionally_inputWrap__8sZjT","groupItem":"consultationFormAdditionally_groupItem__Iaa9M","comment":"consultationFormAdditionally_comment__lnUsh"};